export default __webpack_public_path__ + "static/media/domestic-b.735aa50a.png";